import { render, staticRenderFns } from "./CollectCDCheck.vue?vue&type=template&id=6a4a06c8"
import script from "./CollectCDCheck.vue?vue&type=script&lang=js"
export * from "./CollectCDCheck.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports